import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

function PaymentSuccess({ show, handleClose }) {
  return (
    <>
      <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
        <Modal.Header className="bg-dark" closeButton closeVariant="white">
          <Modal.Title />
        </Modal.Header>
        <Modal.Body className="bg-dark text-center" closeButton>
          <Row className="mb-4">
            <FontAwesomeIcon icon={faCheckCircle} className="fa-location-icon select-color" style={{ fontSize: '12rem' }} />
          </Row>
          <h3 className="text-white-50">Your payment was successful</h3>
          <p>Select and our hotel partners hope that you enjoy your stay. Safe travels!</p>
          <p>You can see the reservation details under the Account &#x3e; Hotel Bookings menu.</p>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PaymentSuccess;
